import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '../../../shared';
import { TranslateModule } from '@ngx-translate/core';
import { BreatheExercisePage } from './breathe-exercise';
import { translateConfig } from '../../config/translate.config';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    BreatheExercisePage
  ],
  imports: [
    IonicModule,
    CommonModule,
    RouterModule.forChild([{ path: '', component: BreatheExercisePage }]),
    TranslateModule.forChild(translateConfig),
    SharedModule
  ],
  exports: [
    BreatheExercisePage
  ],
  providers: []
})
export class BreathExercisePageModule {}
